import { Col, DatePickerField } from '@/components';
import { PS_DEFAULT_SEARCH_START_YEAR } from '@/features/public-site/utils/constants';
import type { ProjectSearchFormType } from '@/features/search/_models/projects-search';
import { useProjectsSearchStore } from '@/features/search/_stores/projects-search-store';
import { COL_MIN_WIDTH } from '@/features/search/_utils/projects-search';
import { isPS } from '@/utils/system';
import dayjs from 'dayjs';
import { type FC, memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const FiscalYearColField: FC = memo(() => {
  const { type } = useProjectsSearchStore();
  const { t } = useTranslation();

  const {
    control,
    formState: { errors },
  } = useFormContext<ProjectSearchFormType>();

  return (
    <Col span={4} style={{ minWidth: COL_MIN_WIDTH.basic }}>
      <DatePickerField
        name="fiscalYear"
        label={t('created-fiscal-year')}
        hint={t('hint-search-fiscal-year')}
        control={control}
        errors={errors}
        picker="year"
        fieldStyle={{ width: '100%' }}
        allowClear={false}
        disabledDate={
          isPS()
            ? (value) => {
                return value.isBefore(
                  dayjs().year(PS_DEFAULT_SEARCH_START_YEAR),
                  'year',
                );
              }
            : undefined
        }
        disabled={type === 'group'}
      />
    </Col>
  );
});
